export default __webpack_public_path__ + "static/media/grandma.a8cb7401.png";